const Theme = {
  Light: 'light',
  Dark: 'dark',
}

export { Theme }
